import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsMerchantNetworkMerchantSchema = withDefaults({
  type: 'pcs-merchant-network-merchant',
  fields: [
    {
      kind: 'attribute',
      name: 'dataState',
    },
    {
      kind: 'attribute',
      name: 'dataStateLog',
    },
    {
      kind: 'attribute',
      name: 'deletedAt',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      // What this pair does in a swipe, as ruled by Payment Operations: 'fee-leg' |
      // 'charge-leg' | 'combined'. Null until ruled. Descriptive — a 100%-fee observation at
      // a fee-leg pair is expected, not a variance.
      kind: 'attribute',
      name: 'role',
    },
    {
      // Ruled fee-to-charge ratio of the WHOLE logical swipe this pair takes part in
      // (0.025 === 2.5%). Null means no ruling yet, so the program's 4% cover applies; 0
      // means Payment Operations ordained a no-fee merchant, the tightest enforcement
      // there is. Never test this with truthiness — 0 is a ruling.
      kind: 'attribute',
      name: 'combinedRate',
    },
    {
      // Inner keys stay snake_case: the value formatter passes hashes through verbatim.
      kind: 'attribute',
      name: 'identities',
    },
    {
      kind: 'belongsTo',
      name: 'pcsMerchant',
      type: 'pcs-merchant',
      options: {
        async: false,
        inverse: 'pcsMerchantNetworkMerchants',
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsNetworkMerchant',
      type: 'pcs-network-merchant',
      options: {
        async: false,
        inverse: 'pcsMerchantNetworkMerchants',
      },
    },
  ],
});

export default PcsMerchantNetworkMerchantSchema;
